import { render, staticRenderFns } from "./DeleteCabinet.vue?vue&type=template&id=bd53e1be&"
import script from "./DeleteCabinet.vue?vue&type=script&lang=ts&"
export * from "./DeleteCabinet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports